import axios from "axios";
const baseUrl = "/api/v1";

export const visits = {
  delete: (id, payload) =>
    axios.delete(`${baseUrl}/visits/${id}`, { data: payload }),
  getDeleteOptions: (id) => axios.get(`${baseUrl}/visits/${id}/delete_options`),
};
